import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { motion, AnimatePresence } from 'framer-motion'
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.svg'
import LanguageSelection from './languageSelection';
import { IoMdClose } from 'react-icons/io';
import { RiMenu2Fill } from 'react-icons/ri';
import bg1 from '../../assets/images/bg1.svg'
import { changeShowMenu } from '../../redux/slices/showMenuSlice';
import Background from '../animation/background';
import { FaLinkedinIn, FaBehance } from "react-icons/fa";
import { RiInstagramFill, RiTwitterXLine } from "react-icons/ri";
import { ImFacebook2 } from "react-icons/im";

const MobileHeader = () => {
    const dispatch = useDispatch();
    const showMenu = useSelector((state) => state.showMenu.showMenu);
    const lang = useSelector((state) => state.lang.lang);


    return (
        <AnimatePresence>
            {showMenu && (
                <motion.div
                    className='mobile-header'
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                >
                    <motion.div
                        className='menu'
                        initial={{ x: "100%" }}
                        animate={{ x: 0 }}
                        exit={{ x: "100%" }}
                        transition={{ duration: 0.4, ease: "easeInOut" }}
                    >
                        {/* <img src={bg1} alt='' className='mobile-bg' /> */}
                        <Background />
                        <div className='content'>
                            <div className='menu-header'>
                                <div><Link onClick={() => dispatch(changeShowMenu(!showMenu))} to="/"><img src={logo} alt='' /></Link></div>
                                <div className='d-flex justify-content-end'>
                                    {/* <LanguageSelection /> */}
                                    <div className='mobile-menu-btn ml-3' onClick={() => dispatch(changeShowMenu(!showMenu))}>
                                        {showMenu ? <IoMdClose size={30} /> : <RiMenu2Fill size={30} />}
                                    </div>
                                </div>
                            </div>
                            <div className='menus'>
                                <div><Link onClick={() => dispatch(changeShowMenu(!showMenu))} to={lang === "tr" ? "/about-us" : "/about-us"}>ABOUT US</Link></div>
                                {/* <div><Link onClick={() => dispatch(changeShowMenu(!showMenu))} to={"#"}>SERVICES</Link></div> */}
                                
                                <div className="mt-5">
                                    <div>
                                        <Link to="#">SERVICES</Link>
                                    </div>
                                    
                                    <ul className='mt-3 submenu-list'>
                                        <li className='mt-2' ><Link onClick={() => dispatch(changeShowMenu(!showMenu))} to={lang === "tr" ? "/software" : "/software"}>SOFTWARE</Link></li>
                                        <li className='mt-2 '><Link onClick={() => dispatch(changeShowMenu(!showMenu))} to={lang === "tr" ? "/hardware" : "/hardware"}>HARDWARE</Link></li>
                                    </ul>
                                </div>
                                
{/*                         
                                <div className="mt-5"><Link onClick={() => dispatch(changeShowMenu(!showMenu))} to={lang === "tr" ? "/software" : "/software"}>SOFTWARE</Link></div>
                                <div className="mt-5"><Link onClick={() => dispatch(changeShowMenu(!showMenu))} to={lang === "tr" ? "/hardware" : "/hardware"}>HARDWARE</Link></div> */}
                                <div className="mt-5"><Link onClick={() => dispatch(changeShowMenu(!showMenu))} to={lang === "tr" ? "/references" : "/references"}>REFERENCE</Link></div>
                                {/* <div><Link onClick={() => dispatch(changeShowMenu(!showMenu))} to={lang === "tr" ? "/career" : "/career"}>CAREER</Link></div> */}
                                <div className="mt-5"><Link onClick={() => dispatch(changeShowMenu(!showMenu))} to={lang === "tr" ? "/contact" : "/contact"}>CONTACT</Link></div>
                            </div>
                            <div className='bottom'>
                                <div>
                                    <div><span>Let’s grab some coffee. ☕️</span></div>
                                    <div className='mt-2'><span>We are waiting you...</span></div>
                                    <div className='my-3'><Link to="mailto:bilgi@liberyus.com">bilgi@liberyus.com</Link></div>
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <div className='mx-2'><Link to="https://www.linkedin.com/company/liberyus/"><FaLinkedinIn color="#000000" size={24} /></Link></div>
                                        <div className='mx-2'><Link to="https://www.facebook.com/liberyus/"><ImFacebook2 color="#000000" size={20} /></Link></div>
                                        <div className='mx-2'><Link to="https://www.instagram.com/liberyus/"><RiInstagramFill color="#000000" size={23} /></Link></div>
                                        <div className='mx-2'><Link to="https://www.x.com/liberyus/"><RiTwitterXLine color="#000000" size={20} /></Link></div>
                                        <div className='mx-2'><Link to="https://www.be.com"><FaBehance color="#000000" size={23} /></Link></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>

    )
}

export default MobileHeader
